
    import { initI18n } from "/js/i18n.js";
    initI18n();
  